import { liveChannelActions } from '@/actions/liveChannelActions'

const initialState = {
  liveList: [],
  params: { page: 1, pageSize: 10, type: 6 },
  position: 0,
  liveNoMore: false
}
export default (state = initialState, { payload, type }) => {
  switch (type) {
    case liveChannelActions.LIVE_LIST:
      return {
        ...state,
        liveList: payload
      }
    case liveChannelActions.LIVE_PARAMS:
      return {
        ...state,
        params: payload
      }
    case liveChannelActions.LIVE_POSITION:
      return {
        ...state,
        position: payload
      }
    case liveChannelActions.LIVE_NOMORE:
      return {
        ...state,
        liveNoMore: payload
      }
    default:
      return state
  }
}
